<script lang="ts" setup>
import { Icon } from '@iconify/vue'

const props = withDefaults(
  defineProps<{
    icon: string
    size?: number
    color?: string
  }>(),
  {
    size: 18,
  },
)

const isPrimeIcon = props.icon.startsWith('pi ')
</script>

<template>
  <i v-if="isPrimeIcon" :class="icon" :style="{ fontSize: `${size}px`, color }" />
  <Icon v-else :icon="icon" :style="{ fontSize: `${size}px`, color }" />
</template>
